export default function ReturnPageDirectory(url) {
    if (!url) return undefined;
    let PageDirectory = undefined;
    switch (url) {
        case "/inspection":
            PageDirectory = ["/inspection"];
            break;
        case "/inspection/shorttermWarranty/list":
            PageDirectory = ["/inspection", "/inspection/shorttermWarranty/list"];
            break;
        case "/inspection/longtermWarranty/list":
            PageDirectory = ["/inspection", "/inspection/longtermWarranty/list"];
            break;
        case "/inspection/accountManagement/list":
            PageDirectory = ["/inspection", "/inspection/accountManagement/list"];
            break;
        case "/inspection/propertyAssignment/list":
            PageDirectory = ["/inspection", "/inspection/propertyAssignment/list"];
            break;
        case "/inspection/visitReport/customerlist":
            PageDirectory = ["/inspection", "/inspection/visitReport/customerlist"];
            break;
        case "/inspection/visitReport/customerlist/reportlist":
            PageDirectory = ["/inspection", "/inspection/visitReport/customerlist", "/inspection/visitReport/customerlist/reportlist"];
            break;
        default:
            break;
    }

    return PageDirectory;
}
